// @ts-strict-ignore
import type { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import type { FeatureNode, FeaturesTree, TaggingPayload } from '../models'
import type { FeatureConfigProvider } from '../providers/interfaces/feature-config.provider'
import { CONTAINER } from '../config/inversify.config'
import { TYPES } from '../config/inversify.types'
import { FeatureIdEnum } from '../enums'

export class TaggingUtils {
  static getTaggingPayload(featureId: FeatureIdEnum, domain?: DomainEnum): TaggingPayload {
    const getFeatureConfigProvider = CONTAINER.get<FeatureConfigProvider>(
      TYPES.FeatureConfigProvider,
    )
    const {
      taggingConfig: { context, category, id: tool },
    } = getFeatureConfigProvider(featureId, { domain })

    if (!category || !tool) {
      return
    }

    return {
      context,
      category,
      tool,
    }
  }

  static removeBrowseAnalyticsFromFeaturesTree(featuresTree: FeaturesTree): FeaturesTree {
    const browseFeatures = (featuresTree.browse || []).filter(
      (featureNode: FeatureNode) => featureNode.id !== FeatureIdEnum.INSIGHTS,
    )
    return {
      ...featuresTree,
      browse: browseFeatures,
    }
  }
}
